const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Button, Grid2, Backdrop, CircularProgress } from '@mui/material';

class CountButton extends Component {
    constructor(props) {
        super(props);
        this.state = { vote_font: '', vote_btn: '' };
    }

    componentDidMount = () => {
        this.setState({
            vote_font: this.props.settings.color.votes_button_font_color,
            vote_btn: this.props.settings.color.votes_button_bgcolor,
        });
    }

    toggleHovertwo = (value, val, name) => () => {
        this.setState({ vote_font: value, vote_btn: val })
    }
    toggleleavetwo = (value, val, name) => () => {
        this.setState({ vote_font: value, vote_btn: val })
    }

    render() {
        const { t } = this.props;
        const { votes_count_font_size, votes_count_font_color, votes_count_bgcolor } = this.props.settings.color;
        if (this.props.singlepost) {
            return (
                <Grid2>
                    <Button
                        variant="contained"
                        className="wpvc_vote_counts"
                        style={{ fontSize: votes_count_font_size + 'px', 'color': votes_count_font_color, 'background': votes_count_bgcolor }}
                    >
                        {this.props.singlepost.votes_count + " "}{t("fr_votes")}
                    </Button>
                </Grid2>
            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }

    }
}

export default connect()(withTranslation("translations")(CountButton));
